import { initializeApp } from "firebase/app";
import {getAuth, GoogleAuthProvider, signInWithPopup} from "firebase/auth"

const firebaseConfig = {
  apiKey: "AIzaSyD8BQh7LZx1tJi-kAiCDPI-Bu7L8Ar4lfo",
  authDomain: "connect-us-41f43.firebaseapp.com",
  projectId: "connect-us-41f43",
  storageBucket: "connect-us-41f43.appspot.com",
  messagingSenderId: "608692925925",
  appId: "1:608692925925:web:02d8c787c1edf37bd5ab0c",
  measurementId: "G-PFTVNFT35K"
};

const app = initializeApp(firebaseConfig);
export const auth =  getAuth(app)

const provider = new GoogleAuthProvider();

export const signInWithGoogle = () => {
  signInWithPopup(auth, provider).then((result) =>{
    console.log(result);
  }).catch((error) =>{
    console.log(error)
  })
}